// @ts-nocheck
import createResizeDetector from "element-resize-detector";
import React, { MutableRefObject, useEffect, useRef } from "react";

interface WithOnResizeProps {
    as?: string | null;
    dimension?: "" | "width" | "height";
    children: React.ReactNode;
    onResize: (width: number, height: number) => void;
    [x: string]: any;
}

const erd = createResizeDetector({ strategy: "scroll" });
const watchers: any[] = [];
function getWatcher(elem: any) {
    for (var i = 0; i < watchers.length; ++i) {
        if (watchers[i].elem == elem) return watchers[i];
    }
    var v = { elem, width: 0, height: 0 };
    watchers.push(v);
    return v;
}

export const ResizeWatch = React.forwardRef<MutableRefObject<any>, WithOnResizeProps>(
    ({ as, dimension, onResize, children, ...props }, ref) => {
        const lastSize = useRef({ w: 0, h: 0 });
        const debouncedOnResize = onResize;

        if (!ref) ref = useRef(null);

        const sizeWatcher = (element: { offsetWidth: any; offsetHeight: any }) => {
            var w = element.offsetWidth;
            var h = element.offsetHeight;
            var z = getWatcher(element);
            var w_changed = w !== z.width;
            var h_changed = h !== z.height;
            var changed = dimension === "width" ? w_changed : dimension === "height" ? h_changed : w_changed || h_changed;
            z.width = w;
            z.height = h;
            if (changed) debouncedOnResize(w, h);
        };

        useEffect(() => {
            //return () => debouncedOnResize.cancel();
        }, []);

        useEffect(() => {
            const element = ref.current;
            if (!onResize || !element) return;
            const w = element.offsetWidth;
            const h = element.offsetHeight;
            const z = lastSize.current;
            const w_changed = w !== z.width;
            const h_changed = h !== z.height;
            const changed = dimension === "width" ? w_changed : dimension === "height" ? h_changed : w_changed || h_changed;
            lastSize.current = { w, h };
            if (changed) debouncedOnResize(w, h);
        });

        useEffect(() => {
            var instance = ref.current;
            if (!onResize || !instance) return;
            erd.listenTo(instance, sizeWatcher);
            return () => erd.uninstall(instance);
        }, [ref, ref.current]);

        props = { ...props, ref };
        if (!as) as = "div";

        return React.createElement(as, props, children);
    }
);
